import Header from './header';

export default class UserHeader {
  public static header: Header[] = [
    {
      text: 'Email',
      align: 'start',
      sortable: true,
      value: 'email',
      class: 'truncate',
      width: ''
    },
    {
      text: 'Edit',
      align: 'right',
      value: 'actions',
      sortable: false,
      class: null,
      width: '5%'
    }
  ];
}
